// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bd7555d8","455":"67c23481","977":"fd9ada6a"}[chunkId] + ".chunk.js";
};